import { type FC, useState } from "react"
import { type UseFormReturn, useFormContext } from "react-hook-form"

import { useGetPaymentTerms } from "./hooks/useGetPaymentTerms"

import { AutoComplete } from "@/components/common/Autocomplete"
import type { CompanyAccountingTerm } from "@/graphql/codegen/graphql"
import type { PaymentTermsFormValues } from "@/screens/CompanySettings/Accounting/schemas/paymentTermsFormSchema"

interface Props {
  label: string
  fieldName: keyof PaymentTermsFormValues
  methods: UseFormReturn<PaymentTermsFormValues>
  currentAccountingTerm?: CompanyAccountingTerm
}

export const PaymentTermsSelector: FC<Props> = ({ label, fieldName, methods, currentAccountingTerm }) => {
  const [searchTerm, setSearchTerm] = useState("")
  const { watch } = useFormContext<PaymentTermsFormValues>()
  const { paymentTermList, paymentTermListFetching } = useGetPaymentTerms({ searchTerm })
  const fieldValue = watch(fieldName)

  return (
    <AutoComplete
      control={methods.control}
      name={fieldName}
      label={label}
      placeholder='Search Payment Terms'
      options={paymentTermList.map((paymentTerm) => paymentTerm.paymentTermId)}
      getOptionLabel={(paymentTermId) => {
        if (fieldValue === currentAccountingTerm?.paymentTermId) {
          return currentAccountingTerm?.paymentTerm?.name || ""
        }

        const paymentTerm = paymentTermList.find((b) => b.paymentTermId === paymentTermId)
        return paymentTerm?.name || ""
      }}
      onInputChange={setSearchTerm}
      defaultEmptyState=''
      loading={paymentTermListFetching}
    />
  )
}
